import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch, ILazyParams, baseUrl } from "../../shared/Fetch";
import { Dialog } from "primereact/dialog";
import { Table } from "../showTimesheet/Table";
import { ILogin, IPermissionProps } from "../../models/Login";
import { IPurchaseOrder } from "../../models/PurchaseOrder";
import { Panel } from "primereact/panel";
import { Filter, InvoiceTrackingFilter } from "./Filter";
import { format } from "date-fns";
import { JVDropdown } from "../../shared/JVDropdown";
import { useForm } from "react-hook-form";
// import { Form } from "./GenerateInvoice";
import { JVInput } from "../../shared/JVInput";
import { SubVendorInvoices } from "../subVendorInvoices";
import { GenerateInvice } from "../subVendorInvoices/GenerateInvice";
import { InputTextarea } from "primereact/inputtextarea";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { safeFormatDate } from "../../models/DateFormatMapper";

export interface InvoiceTracking {
    addedBy?: string,
    client?: string,
    consultant_ID?: number,
    consultant_Name?: string,
    dueDate?: string,
    end_Client?: string,
    fromDate?: string,
    invoiceAmount?: number,
    invoiceHours?: number,
    invoiceNo?: string,
    invoicePath?: string,
    invoice_ID?: number,
    job_Titles?: string,
    mRate?: number,
    pO_ID?: number,
    prime_Vendor_Billing_Cycle?: string,
    prime_Vendor_Payment_Term?: string,
    sRate?: number,
    sales?: string,
    start_Date?: string,
    timeSheet_Status1?: string,
    toDate?: string,
    vendor?: string,
    verfiedBy?: number,
    verifiedBy?: string,
    invoiceStatus?: string,
    createdOn?: string,
    verifyComment?: string,
    paymentStatus?: string,
    balance_Rate?: number,
    receivedAmount?: number,
    payment_Mode?: string,
    transaction_ID?: string,
    isInoviceRemitance?: boolean,
    aging?: number,
    credit_Note_Comment?: string,
    releasePaymentDate?: Date,
    releasePaymentType?: number,
    isCalculated?: boolean,
    invoiceDate?: Date,
    payment_Date?: Date,
};



interface IProps {
    permissions: IPermissionProps,
    toast: any,
}

export const EmptyFilter: InvoiceTrackingFilter = {
    year: null,
    month: null,
    vendor_Company: { vendor_Company_ID: 0, vendor_Company_Name: "" },
    prime_Vendor_Billing_Cycle: null,
    invoiceStatus: null,
    paymentStatus: null,
    dueDateFrom: null,
    dueDateTo: null,
    consultant: {
        consultant_ID: 0,
        consultant_Name: ""
    },
    invoiceNO: "",
    releaseStatus: null,
}


export const InvoiceIncentiveTable = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: InvoiceTracking[], loading: boolean });
    const [totalRecords, setTotalRecords] = useState(0);
    const [invoiceFilter, setInvoiceFilter] = useState<InvoiceTrackingFilter>(EmptyFilter);
    const [loading, setLoading] = useState(false);
    const [isCreditNoteOpen, setIsCreditNoteOpen] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [credit_Note_Comment, setCredit_Note_Comment] = useState("");

    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 100,
        page: 1,
        sortField: 'consultant_ID',
        sortOrder: -1
    });

    const _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const consultant_Name = (rowData: InvoiceTracking) => {
        return (
            <>
                <span className={"cursor-pointer underline " + (rowData.paymentStatus === "Pending" ? "text-white" : "text-cyan-700")}>{rowData?.consultant_Name}</span>
            </>
        );
    };

    useEffect(() => {
        if (isCreditNoteOpen.open) {
            if (isCreditNoteOpen.singleData.credit_Note_Comment != null && isCreditNoteOpen.singleData.credit_Note_Comment.trim() != "") setCredit_Note_Comment(isCreditNoteOpen.singleData.credit_Note_Comment);
        };
    }, [isCreditNoteOpen.open]);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });

        let updateInvoiceFilter: any = invoiceFilter;
        updateInvoiceFilter.vendor_Company = invoiceFilter.vendor_Company?.vendor_Company_ID;
        updateInvoiceFilter.consultantName = invoiceFilter.consultant?.consultant_Name;

        let po_id_Query = "";

        const response = await Fetch("InvoiceTracking/getallcalculatedincentiveinvoices", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}&filter=` + encodeURIComponent(JSON.stringify(updateInvoiceFilter)) + po_id_Query, props.toast);
        if (response) {
            const data: InvoiceTracking[] = await response.json();
            setTableData({ tableData: data, loading: false });
            setTotalRecords(data.length);
        } else setTableData({ tableData: tableData.tableData, loading: false });
    }

    const fromDate = (rowData: any) => {
        let date;
        if (rowData.fromDate) date = format(new Date(rowData.fromDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const toDate = (rowData: any) => {
        let date;
        if (rowData.toDate) date = format(new Date(rowData.toDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const rowClass = (data: any) => {
        return {
            'bg-green-300 text-black': data.releaseStatus === true,
        };
    }

    useEffect(() => {
        //setConsultantAllInvoices({ singleData: 0, open: false });
        loadTableData();
    }, [lazyParams, invoiceFilter]);

    const DateFormat = loginObj.date_Format;
    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter invoiceFilter={invoiceFilter} setReqFilter={(invoiceFilter: InvoiceTrackingFilter) => setInvoiceFilter(invoiceFilter)} toast={props.toast} byPO_ID={false} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                value={tableData.tableData}
                loading={tableData.loading}
                dataKey="id"
                paginator
                rows={100}
                rowsPerPageOptions={[5, 10, 20, 50, 100]}
                rowClassName={rowClass}
            >
                <Column header="SN." body={(rowData, options) => options.rowIndex + 1} />
                <Column field="user_Name" header="User" />
                <Column field="role_Name" header="Role" />
                <Column field="invoiceNO" header="#Invoice No" />
                <Column field="consultant_Name" header="Consultant Name" body={consultant_Name} />
                <Column field="prime_Vendor_Company" header="Prime Vendor Company" />
                {/* <Column field="fromDate" header="From Date" body={fromDate} /> */}
                <Column field="fromDate" header="From Date" body={(rowData: any)=> safeFormatDate(rowData.fromDate, 'dd/MM/yyyy', DateFormat)} />
                <Column field="toDate" header="To Date" body={toDate} />
                <Column field="invoiceHours" header="Hours" />
                <Column field="sRate" header="Rate" />
                <Column field="invoiceAmount" header="Amout" />
                <Column field="createdOn" header="Created On" body={(rowData: InvoiceTracking) => {
                    let date;
                    if (rowData.createdOn) date = format(new Date(rowData.createdOn), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<p>{date}</p>);
                }} />
                <Column field="payment_Date" header="Payment Date" body={(rowData: InvoiceTracking) => {
                    let date;
                    if (rowData.payment_Date) date = format(new Date(rowData.payment_Date), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<>{date}</>);
                }} />
                <Column field="receivedAmount" header="Received Amount" />
                <Column field="createdOn" header="Calculated On" body={(rowData) => {
                    let date;
                    if (rowData.createdOn) date = format(new Date(rowData.createdOn), 'dd/MM/yyyy').toUpperCase();
                    else date = "";
                    return (<>{date}</>);
                }} />
                <Column field="holdStatus" header="Hold Status" body={(rowData) => <p>{rowData.holdStatus === true ? "Yes" : "No"}</p>} />
                <Column field="releaseStatus" header="Release Status" body={(rowData) => <p>{rowData.releaseStatus === true ? "Yes" : "No"}</p>} />
            </DataTable>

        </>
    );
}